//#region types
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { BaseFormExpandableStepProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { CostForwardingSection } from "components/costForwardingMarking";
//#endregion

const CostForwardingStep: React.FC<BaseFormExpandableStepProps<IncomingInvoiceFormTypes.Todo>> = ({
  connect,
  values,
  expandableStepProps,
}) => <CostForwardingSection connect={connect} values={values} expandableStepProps={expandableStepProps} />;

export default CostForwardingStep;
